import { createContext } from 'react';

/**
 * When true, SystemAuthor falls back to the Aura icon instead of the Lightbulb.
 * Provided only by the digital-twins chat screen; every other chat keeps the Lightbulb.
 */
export const UseAuraSystemAuthorIconContext = createContext<boolean>(false);
